import axios from 'axios';
import './axios-interceptor';

export default {
  async registerEvent(eventId: string) {
    return await axios.post(`myevent/register`, {
      eventId: eventId,
    });
  },
  async getMyEvent(param: any, searchParam: string) {
    return await axios.get(`myevent/list?limit=${param.limit}&${searchParam}`);
  },
};
